/* Boboné — PDP "Complétalo en kit" bundle offer.
   Shows the kit card(s) whose color matches the selected variant and hides the
   rest; hides the whole module when the current color has no in-stock kit.
   Also drives the fixed "barra fija" nudge (.bobone-kitbar): relocated to
   <body> so position:fixed escapes the info column's transform, shown only when
   a kit exists for the color, and slid away once the card scrolls into view.

   Progressive enhancement: the default color's card is already visible from the
   server (snippet + :has() CSS fallback), so if we can't read the variant we
   leave the server state untouched rather than blanking the module. */
(function () {
  var barBySection = {};

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // Match Liquid's `handleize`: strip accents, lowercase, non-alphanumerics -> "-".
  function slug(v) {
    return (v == null ? '' : String(v))
      .normalize('NFD').replace(/[^\w\s-]/g, '')
      .trim().toLowerCase()
      .replace(/\s+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
  }

  function selectedColor(module) {
    var pos = parseInt(module.dataset.colorOption, 10);
    if (!pos) return '';
    var vs = document.getElementById('variant-selects-' + module.dataset.sectionId);
    var script = vs && vs.querySelector('[data-selected-variant]');
    if (!script) return '';
    try {
      var v = JSON.parse(script.textContent);
      if (v && Array.isArray(v.options) && v.options[pos - 1] != null) return slug(v.options[pos - 1]);
    } catch (e) {}
    return '';
  }

  // Show/position the fixed bar for a module: hidden when the module has no kit
  // for the current color, otherwise visible unless the card is already on screen.
  function syncBar(module) {
    var bar = barBySection[module.dataset.sectionId];
    if (!bar) return;
    if (module.hidden) { bar.hidden = true; return; }
    bar.hidden = false;
    bar.classList.toggle('is-away', module._cardInView === true);
  }

  function apply(module, colorSlug) {
    var shown = 0;
    module.querySelectorAll('.bobone-bundle__card').forEach(function (card) {
      var match = colorSlug !== '' && card.dataset.color === colorSlug;
      card.hidden = !match;
      if (match) shown += 1;
    });
    module.hidden = shown === 0;
    syncBar(module);
  }

  function setupBars(root) {
    (root || document).querySelectorAll('[data-bobone-kitbar]').forEach(function (bar) {
      if (bar.dataset.kitbarReady) return;
      var sid = bar.dataset.sectionId;
      var module = document.querySelector('[data-bobone-bundle][data-section-id="' + sid + '"]');
      if (!module) return;
      bar.dataset.kitbarReady = '1';
      // Replace any stale bar for this section (e.g. theme-editor section reload).
      if (barBySection[sid] && barBySection[sid] !== bar) barBySection[sid].remove();
      barBySection[sid] = bar;
      document.body.appendChild(bar); // escape transformed ancestors so fixed pins to the viewport

      bar.addEventListener('click', function () {
        var target = module.querySelector('.bobone-bundle__cards') || module;
        try { target.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'center' }); }
        catch (e) { target.scrollIntoView(); }
      });

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            module._cardInView = en.isIntersecting;
            syncBar(module);
          });
        }, { threshold: 0.28 });
        io.observe(module);
      }
      syncBar(module);
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-bobone-bundle]').forEach(function (m) {
      var c = selectedColor(m);
      if (c) apply(m, c); // only refine when we could actually read the color
    });
    setupBars(root);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data) return;
      document
        .querySelectorAll('[data-bobone-bundle][data-section-id="' + data.sectionId + '"]')
        .forEach(function (module) {
          var pos = parseInt(module.dataset.colorOption, 10);
          var color = (data.variant && Array.isArray(data.variant.options) && pos)
            ? slug(data.variant.options[pos - 1])
            : '';
          apply(module, color);
        });
    });
  }
})();
